export default "__VITE_ASSET__d2a851b3__"